/**
 * Middleware to check if the user is already connected, and redirect it accordingly.
 */
import Promise from 'promise-polyfill';
import CookieManager from '../../../centiva-assets/frontend/utils/CookieManager';
import i18n from '@/translations';
import Store from '@/store';

const ALLOWED_PATHS = [];
Object.keys(i18n.messages).forEach((locale) => {
	ALLOWED_PATHS.push(i18n.messages[locale].routes.logout);
	ALLOWED_PATHS.push(i18n.messages[locale].routes['reset-password']);
	ALLOWED_PATHS.push(i18n.messages[locale].routes['forgot-password']);
});

export default {
	run: (to, from, next) => {
		if (ALLOWED_PATHS.indexOf(to.path) === -1) {
			const cookieManager = new CookieManager();
			const environment = process.env.VUE_APP_ENV;
			const protocol = process.env.VUE_APP_CENTIVA_PROTOCOL;

			const getTokenName = id => `${environment}_${id}`;

			const all = tokenIds => new Promise((resolve, reject) => {
				const tokens = [];
				for (let i = 0; i < tokenIds.length; i += 1) {
					const token = getTokenName(tokenIds[i]);
					if (!cookieManager.get(tokenIds[i])) return reject();
					tokens.push(token);
				}
				return resolve();
			});

			const redirectToCentiva = () => {
				let redirectDomain = Store.getters['application/getRedirect'];
				if (redirectDomain == null) {
					redirectDomain = `${protocol}://${process.env.VUE_APP_CENTIVA_DOMAIN}`;
				}
				window.location = redirectDomain;
			};

			const saveRefreshedToken = (response) => {
				const { data } = response;

				if (data && data.data && data.AccessToken && data.IdToken) {
					cookieManager.set('cat', data.AccessToken, '30d');
					cookieManager.set('crt', data.IdToken, '30d');
				}
			};

			return all(['cat', 'crt', 'cit'])
				.then(() => Store.dispatch('sso/VALIDATE_TOKENS', {
					accessToken: cookieManager.get('cat'),
					refreshToken: cookieManager.get('crt'),
					refresh: true,
				}))
				.then(saveRefreshedToken)
				.then(redirectToCentiva)
				.catch(() => {
					const accessToken = cookieManager.get('cat');
					const refreshToken = cookieManager.get('crt');

					if (accessToken != null && refreshToken != null) {
						return Store.dispatch('sso/VALIDATE_TOKENS', {
							accessToken,
							refreshToken,
							refresh: false,
						});
					}
					throw new Error();
				})
				.then(redirectToCentiva)
				.catch(() => {
					next();
					return false;
				});
		}
		return false;
	},
};
